/*
 * MEEM ARABIC — BUNDLE IMAGE QUICK PREVIEW
 * Version: 23 October 2026
 * Single Shopify asset for the homepage and the four individual bundle pages.
 * Desktop: hover a small bundle image. Mobile: press and hold, or tap.
 * Keyboard: focus the image and press Enter/Space. Esc closes the preview.
 * Does not touch checkboxes, pricing, cart logic, product templates or discounts.
 */
(() => {
  'use strict';
  if (window.__meemBundleImagePreviewV1) return;
  window.__meemBundleImagePreviewV1 = true;

  const BUNDLES = {
    alphabet: { handle: 'arabic-alphabet-bundle', name: 'Arabic Alphabet' },
    reading: { handle: 'reading-vocabulary-bundle', name: 'Reading & Vocabulary' },
    essentials: { handle: 'arabic-essentials-bundle', name: 'Arabic Essentials' },
    fun: { handle: 'fun-activities-bundle', name: 'Fun Activities' }
  };

  const css = `
    .meem-preview-trigger {
      display: inline-flex !important; align-items: center; justify-content: center;
      position: relative; flex: 0 0 auto; cursor: zoom-in;
      border-radius: 9px; vertical-align: middle;
      -webkit-tap-highlight-color: transparent; user-select: none;
    }
    .meem-preview-trigger img { display: block; -webkit-user-drag: none; user-select: none; pointer-events: none; }
    .meem-preview-trigger:focus-visible {
      outline: 3px solid #9274c6; outline-offset: 4px;
    }
    .meem-preview-magnify {
      position: absolute; right: -5px; bottom: -5px; width: 21px; height: 21px;
      background: white; border: 1px solid #ddd2ee; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 2px 6px #1d123020; pointer-events: none;
    }
    .meem-preview-magnify svg { width: 11px; height: 11px; }
    .ma-included .meem-preview-trigger--base { margin-right: 4px; }
    .ma-included .meem-preview-trigger--base img {
      width: 50px !important; height: 54px !important; object-fit: contain !important;
      padding: 3px; background: white; border-radius: 7px;
      border: 1px solid #e2dbea;
    }
    .mh-bundle-row .meem-preview-trigger img {
      width: 54px; height: 54px; object-fit: contain;
    }
    #meem-image-peek {
      position: fixed; z-index: 2147483640; width: min(360px, calc(100vw - 24px));
      box-sizing: border-box; padding: 14px; border-radius: 16px;
      background: #fffdf8; border: 1px solid #e5dcea;
      box-shadow: 0 16px 48px #26153a38; pointer-events: none;
      opacity: 0; visibility: hidden; transform: translateY(5px);
      transition: opacity .14s ease, transform .14s ease, visibility .14s;
      color: #2a2137; font-family: inherit;
    }
    #meem-image-peek.is-open {
      visibility: visible; opacity: 1; transform: translateY(0);
    }
    #meem-image-peek .meem-peek-photo {
      display: flex; align-items: center; justify-content: center;
      height: min(390px, 53vh); background: #f2edf9; border-radius: 10px;
      padding: 12px; box-sizing: border-box;
    }
    #meem-image-peek img {
      display: block; width: 100%; height: 100%; max-height: 100%;
      object-fit: contain; object-position: center;
    }
    #meem-image-peek .meem-peek-name { margin: 11px 3px 1px; font-weight: 750; font-size: 15px; }
    #meem-image-peek .meem-peek-note { margin: 0 3px 2px; color: #6b6273; font-size: 11px; }
    #meem-image-overlay[hidden], #meem-image-peek[hidden] { display: none !important; }
    #meem-image-overlay {
      position: fixed; inset: 0; z-index: 2147483641;
      background: #1c1328db; display: flex; align-items: center; justify-content: center;
      box-sizing: border-box; padding: 18px; font-family: inherit;
    }
    #meem-image-overlay .meem-modal-card {
      position: relative; display: flex; flex-direction: column;
      width: min(560px, 100%); max-height: min(92dvh, 900px);
      background: #fffdf8; color: #2a2137; border-radius: 17px;
      box-shadow: 0 20px 70px #0005; padding: 16px;
      box-sizing: border-box;
    }
    #meem-image-overlay .meem-modal-top {
      display: flex; justify-content: space-between; align-items: center;
      gap: 14px; padding: 0 0 12px;
    }
    #meem-image-overlay .meem-modal-title {
      font-size: 16px; font-weight: 750; line-height: 1.3; margin: 0;
    }
    #meem-image-overlay .meem-modal-close {
      flex: 0 0 40px; width: 40px; height: 40px; border-radius: 50%;
      border: 1px solid #e4dbea; color: #39225d; background: white;
      font-size: 27px; line-height: 1; cursor: pointer;
    }
    #meem-image-overlay .meem-modal-photo {
      min-height: 100px; display: grid; place-items: center;
      overflow: auto; background: #f2edf9; border-radius: 10px;
      padding: 10px; box-sizing: border-box;
    }
    #meem-image-overlay .meem-modal-photo img {
      display: block; width: auto; max-width: 100%; height: auto;
      max-height: calc(92dvh - 125px); object-fit: contain;
    }
    #meem-image-overlay .meem-modal-foot {
      margin: 10px 3px 0; text-align: center; color: #6b6273; font-size: 12px;
    }
    @media (max-width: 749px) {
      #meem-image-peek { display: none !important; }
      #meem-image-overlay { padding: 10px; }
      #meem-image-overlay .meem-modal-card { padding: 12px; max-height: 95dvh; }
      #meem-image-overlay .meem-modal-photo img { max-height: calc(95dvh - 119px); }
    }
    @media (prefers-reduced-motion: reduce) {
      #meem-image-peek { transition: none; }
    }
  `;

  const style = document.createElement('style');
  style.id = 'meem-bundle-preview-styles';
  style.textContent = css;
  document.head.appendChild(style);

  const popover = document.createElement('div');
  popover.id = 'meem-image-peek';
  popover.setAttribute('aria-hidden', 'true');
  const peekPhoto = document.createElement('div'); peekPhoto.className = 'meem-peek-photo';
  const peekImg = document.createElement('img'); peekImg.alt = ''; peekImg.width = 750; peekImg.height = 950;
  peekPhoto.appendChild(peekImg);
  const peekName = document.createElement('p'); peekName.className = 'meem-peek-name';
  const peekNote = document.createElement('p'); peekNote.className = 'meem-peek-note';
  peekNote.textContent = 'Click the thumbnail for a larger view';
  popover.append(peekPhoto, peekName, peekNote);

  const overlay = document.createElement('div');
  overlay.id = 'meem-image-overlay';
  overlay.hidden = true;
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Bundle image preview');
  const card = document.createElement('div'); card.className = 'meem-modal-card';
  const top = document.createElement('div'); top.className = 'meem-modal-top';
  const modalTitle = document.createElement('h2'); modalTitle.className = 'meem-modal-title';
  const closeButton = document.createElement('button'); closeButton.type = 'button';
  closeButton.className = 'meem-modal-close'; closeButton.setAttribute('aria-label', 'Close preview');
  closeButton.textContent = '×';
  top.append(modalTitle, closeButton);
  const modalPhoto = document.createElement('div'); modalPhoto.className = 'meem-modal-photo';
  const modalImg = document.createElement('img'); modalImg.alt = ''; modalImg.width = 1100; modalImg.height = 1400;
  modalPhoto.appendChild(modalImg);
  const modalFoot = document.createElement('p'); modalFoot.className = 'meem-modal-foot';
  modalFoot.textContent = 'Preview of the bundle cover';
  card.append(top, modalPhoto, modalFoot); overlay.append(card);

  let activeTrigger = null;
  let hoverTrigger = null;
  let previousOverflow = '';
  let holdTimer = null;
  const productCache = new Map();

  function mountLayers() {
    if (!document.body.contains(popover)) document.body.appendChild(popover);
    if (!document.body.contains(overlay)) document.body.appendChild(overlay);
  }

  function resizeCdnImage(src, width) {
    if (!src) return '';
    try {
      const u = new URL(src, location.href);
      if (!/^https?:$/.test(u.protocol)) return '';
      // Shopify's modern CDN uses ?width=160. Older URLs can contain _160x.
      u.pathname = u.pathname.replace(/_\d+x\d*(?=\.(?:png|jpe?g|webp|gif|avif)$)/i, '_' + width + 'x');
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (_) { return src; }
  }

  function getHandle(row) {
    if (row.classList.contains('mh-bundle-row')) {
      const key = row.querySelector('input[data-bundle]')?.dataset.bundle;
      return BUNDLES[key]?.handle || '';
    }
    if (row.classList.contains('ma-included')) {
      const match = location.pathname.match(/\/products\/([^/?#]+)/);
      return match?.[1] || '';
    }
    const link = row.querySelector('.ma-extra-copy a[href*="/products/"]');
    if (link) {
      try { return new URL(link.href).pathname.match(/\/products\/([^/?#]+)/)?.[1] || ''; }
      catch (_) { /* fall through */ }
    }
    const name = (row.querySelector('[data-extra]')?.dataset.title || row.textContent || '').toLowerCase();
    if (name.includes('alphabet')) return BUNDLES.alphabet.handle;
    if (name.includes('reading')) return BUNDLES.reading.handle;
    if (name.includes('essential')) return BUNDLES.essentials.handle;
    if (name.includes('fun activit')) return BUNDLES.fun.handle;
    return '';
  }

  function getName(row) {
    return (row.querySelector('.mh-bundle-name b, .ma-extra-copy label b')?.textContent ||
      row.querySelector('[data-extra]')?.dataset.title || 'Arabic learning bundle').trim();
  }

  async function requestFeaturedImage(handle) {
    if (!handle) return '';
    if (!productCache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const url = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
      productCache.set(handle, fetch(url, {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
        .then(response => { if (!response.ok) throw Error('No image'); return response.json(); })
        .then(data => data?.featured_image || data?.images?.[0] || '')
        .catch(() => ''));
    }
    return productCache.get(handle);
  }

  function hideHover() {
    hoverTrigger = null;
    popover.classList.remove('is-open');
  }

  function positionHover(trigger) {
    const r = trigger.getBoundingClientRect();
    const width = Math.min(360, window.innerWidth - 24);
    const height = popover.offsetHeight || 465;
    let left = r.right + 15;
    if (left + width + 12 > window.innerWidth) left = r.left - width - 15;
    if (left < 12) left = Math.max(12, (window.innerWidth - width) / 2);
    let y = r.top - 85;
    y = Math.max(12, Math.min(y, window.innerHeight - height - 12));
    popover.style.left = Math.round(left) + 'px';
    popover.style.top = Math.round(y) + 'px';
  }

  function previewUrl(trigger) {
    const img = trigger.querySelector('img');
    return img?.dataset.meemFull || resizeCdnImage(img?.getAttribute('src') || img?.currentSrc, 1100);
  }

  function showHover(trigger) {
    if (!overlay.hidden || !trigger.isConnected || window.innerWidth < 750) return;
    mountLayers();
    hoverTrigger = trigger;
    const img = trigger.querySelector('img');
    if (!img) return;
    peekImg.src = previewUrl(trigger);
    peekName.textContent = trigger.dataset.meemTitle || 'Bundle preview';
    popover.classList.add('is-open');
    positionHover(trigger);
    // If the image was unavailable when the thumbnail was created, try the product's actual cover.
    const handle = trigger.dataset.meemHandle;
    if (handle && !img.dataset.meemFull && !img.src) {
      requestFeaturedImage(handle).then(url => {
        if (hoverTrigger === trigger && url) peekImg.src = resizeCdnImage(url, 1100);
      });
    }
  }

  function openModal(trigger) {
    const img = trigger.querySelector('img');
    if (!img) return;
    mountLayers();
    hideHover();
    activeTrigger = trigger;
    modalTitle.textContent = trigger.dataset.meemTitle || 'Bundle preview';
    modalImg.src = previewUrl(trigger);
    modalImg.alt = (trigger.dataset.meemTitle || 'Bundle') + ' cover preview';
    overlay.hidden = false;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButton.focus({preventScroll: true});
  }

  function closeModal() {
    if (overlay.hidden) return;
    overlay.hidden = true;
    modalImg.removeAttribute('src');
    document.body.style.overflow = previousOverflow;
    if (activeTrigger?.isConnected) activeTrigger.focus({preventScroll: true});
    activeTrigger = null;
  }

  closeButton.addEventListener('click', closeModal);
  overlay.addEventListener('click', event => { if (event.target === overlay) closeModal(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { closeModal(); hideHover(); }
    if (!overlay.hidden && event.key === 'Tab') {
      event.preventDefault(); closeButton.focus();
    }
  });
  window.addEventListener('scroll', hideHover, {passive: true, capture: true});
  window.addEventListener('resize', hideHover, {passive: true});

  function decorate(row, img, options = {}) {
    if (!img || row.querySelector('.meem-preview-trigger')) return;
    const name = getName(row);
    const trigger = document.createElement('span');
    trigger.className = 'meem-preview-trigger' + (options.base ? ' meem-preview-trigger--base' : '');
    trigger.tabIndex = 0;
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-label', 'Preview ' + name + ' image');
    trigger.title = 'Hover to preview • tap or hold to enlarge';
    trigger.dataset.meemTitle = name;
    trigger.dataset.meemHandle = getHandle(row);

    if (options.base) {
      img.classList.add('ma-extra-image');
      img.width = 54;
      img.height = 54;
      img.removeAttribute('srcset');
      const label = row.querySelector('.ma-extra-copy');
      if (label) row.insertBefore(trigger, label);
      else row.append(trigger);
      trigger.appendChild(img);
    } else {
      img.replaceWith(trigger);
      trigger.appendChild(img);
    }

    const zoom = document.createElement('span');
    zoom.className = 'meem-preview-magnify';
    zoom.setAttribute('aria-hidden', 'true');
    zoom.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#56358b" stroke-width="2.5" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg>';
    trigger.appendChild(zoom);

    trigger.addEventListener('pointerenter', e => {
      if (e.pointerType === 'mouse' || e.pointerType === 'pen') showHover(trigger);
    });
    trigger.addEventListener('pointerleave', hideHover);
    trigger.addEventListener('focus', () => {
      if (window.matchMedia('(hover: hover)').matches) showHover(trigger);
    });
    trigger.addEventListener('blur', hideHover);

    let startX = 0, startY = 0, moved = false, pressing = false;
    function clearHold() { if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } }
    trigger.addEventListener('pointerdown', e => {
      startX = e.clientX; startY = e.clientY; moved = false; pressing = true;
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
      clearHold();
      holdTimer = setTimeout(() => {
        holdTimer = null;
        if (!moved) openModal(trigger);
      }, 420);
    });
    trigger.addEventListener('pointermove', e => {
      if (!pressing) return;
      if (Math.abs(e.clientX - startX) > 12 || Math.abs(e.clientY - startY) > 12) {
        moved = true; clearHold();
      }
    });
    trigger.addEventListener('pointerup', () => { pressing = false; clearHold(); });
    trigger.addEventListener('pointercancel', () => { pressing = false; clearHold(); });
    trigger.addEventListener('contextmenu', e => { e.preventDefault(); });
    trigger.addEventListener('click', e => {
      // Crucial for the homepage: the thumbnail lives inside a label/checkbox row.
      // Clicking or holding it must NOT tick/untick a bundle.
      e.preventDefault(); e.stopPropagation();
      if (!moved && overlay.hidden) openModal(trigger);
    });
    trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); e.stopPropagation(); openModal(trigger);
      }
    });
  }

  function createImage(src, name) {
    const img = document.createElement('img');
    img.className = 'ma-extra-image';
    img.alt = name + ' cover';
    img.width = 54; img.height = 54;
    img.loading = 'lazy';
    img.src = resizeCdnImage(src, 160);
    img.dataset.meemFull = resizeCdnImage(src, 1100);
    return img;
  }

  function enhanceRow(row) {
    if (row.querySelector('.meem-preview-trigger') || row.dataset.meemPreviewPending === 'yes') return;
    const home = row.classList.contains('mh-bundle-row');
    const base = row.classList.contains('ma-included');
    const name = getName(row);
    const existing = row.querySelector(home ? '.mh-bundle-photo, img' : '.ma-extra-image');
    if (existing) { decorate(row, existing); return; }

    if (base) {
      // The four product pages do not render an image in their own selected row.
      // Reuse that product page's main cover, so all four rows have previews.
      const productRoot = row.closest('meem-alphabet, meem-reading-vocab, meem-essentials, meem-fun');
      const hero = productRoot?.querySelector('.ma-main-image');
      if (hero?.getAttribute('src')) {
        const img = createImage(hero.getAttribute('src'), name);
        decorate(row, img, {base: true});
        return;
      }
    }

    // Fallback for homepage rows that still have Arabic symbol placeholders,
    // or products whose extra image did not render in the template.
    const handle = getHandle(row);
    if (!handle) return;
    row.dataset.meemPreviewPending = 'yes';
    requestFeaturedImage(handle).then(src => {
      if (!src || !row.isConnected) return;
      const img = createImage(src, name);
      if (home) {
        img.className = 'mh-bundle-photo';
        const symbol = row.querySelector('.mh-bundle-symbol');
        if (symbol) { symbol.replaceWith(img); }
        else { row.querySelector('input')?.after(img); }
        decorate(row, img);
      } else if (base) {
        decorate(row, img, {base: true});
      } else {
        const extraPrice = row.querySelector('.ma-extra-price');
        if (extraPrice) { extraPrice.append(img); decorate(row, img); }
      }
    }).finally(() => { delete row.dataset.meemPreviewPending; });
  }

  function enhanceAll(scope = document) {
    mountLayers();
    scope.querySelectorAll?.('.mh-bundle-row, .ma-bundle-row').forEach(enhanceRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll(), {once: true});
  } else {
    enhanceAll();
  }
  document.addEventListener('shopify:section:load', event => enhanceAll(event.target));
  // Shopify may rebuild sections in the theme editor; support freshly inserted rows.
  let scheduled = false;
  const mutationObserver = new MutationObserver(changes => {
    const containsNewRows = changes.some(change => [...change.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('.ma-bundle-row, .mh-bundle-row') ||
        node.querySelector?.('.ma-bundle-row, .mh-bundle-row'))));
    if (containsNewRows && !scheduled) {
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enhanceAll(); });
    }
  });
  mutationObserver.observe(document.documentElement, {childList: true, subtree: true});
})();
